module.exports = ".w-md {\n    width: 90%;\n}\n"